module.exports = __webpack_public_path__ + "static/media/1.8c6cb891.jpg";